import {asCreator, withCallbacks} from '../../../../lib/utils';
import {compose} from '../../../../utils/functions';
import {actionTypes} from '../../reducers/notificationsReducer';

export const updateUpdatedPersonNotification = compose(
    withCallbacks,
    asCreator((data: any, id: number) => ({
        type: actionTypes.UPDATE_UPDATED_PERSONS,
        payload: data,
        id
    }))
);